import {useLocation} from 'react-router-dom';

const SSO = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get('token');

  localStorage.removeItem('current-fbo');
  localStorage.setItem('ndx_user_token', token);

  window.location.href = '/';
};

export default SSO;
